import React from "react";

const Hero = () => {
  // const style = {
  //   width: "25rem",
  //   height: "22rem",
  //   borderRadius: "1rem",
  // };

  return (
    // <img style={style} src={devIcon} alt="itachi_img" />
    <span></span>
  );
};

export default Hero;
